import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import Header from './components/Header';
import Footer from './components/Footer';
import RequireAdmin from './components/RequireAdmin';
import AdminBar from './components/AdminBar';
import EditDrawer from './components/EditDrawer';
import { EditProvider } from './context/EditContext';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  const clerkReady = !!PUBLISHABLE_KEY;
  return (
    <div className="app">
      {!isAdmin && clerkReady && <AdminBar />}
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminDashboard />
            </RequireAdmin>
          }
        />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && clerkReady && <EditDrawer />}
    </div>
  );
}

function App() {
  const inner = (
    <Router>
      <EditProvider>
        <AppShell />
      </EditProvider>
    </Router>
  );
  if (!PUBLISHABLE_KEY) return inner;
  return <ClerkProvider publishableKey={PUBLISHABLE_KEY}>{inner}</ClerkProvider>;
}

export default App;
